// möglich
export const ALWAYS_POSSIBLE_HEATING_SYSTEMS = ['Pellets'] as const
export type AlwaysPossibleHeatingSystemType = (typeof ALWAYS_POSSIBLE_HEATING_SYSTEMS)[number]

// biomassen with classification
export const BIOMASSE_HEATING_SYSTEMS = ['Hackgut', 'Scheitholz'] as const
export type BioMasseHeatingSystemType = (typeof BIOMASSE_HEATING_SYSTEMS)[number]

// ungeeignet
export const ALWAYS_UNGEEIGNET_HEATING_SYSTEMS = ['Strom', 'Gas', 'Öl', 'FWrot'] as const
export type AlwaysUnsuitableHeatingSystemType = (typeof ALWAYS_UNGEEIGNET_HEATING_SYSTEMS)[number]

// fernwärme
export const FERNWAERME_HEATING_SYSTEMS = ['FWe', 'FW', 'FWh'] as const
export type FernwaermeHeatingSystemType = (typeof FERNWAERME_HEATING_SYSTEMS)[number]

// waermepumpen
export const WAERME_PUMPE_HEATING_SYSTEMS = ['WasserWP', 'SoleWP', 'KollektorWP', 'LuftWP'] as const
export type WaermePumpeHeatingSystemType = (typeof WAERME_PUMPE_HEATING_SYSTEMS)[number]

export const HEATING_SYSTEMS = [
	...ALWAYS_UNGEEIGNET_HEATING_SYSTEMS,
	...BIOMASSE_HEATING_SYSTEMS,
	...ALWAYS_POSSIBLE_HEATING_SYSTEMS,
	...WAERME_PUMPE_HEATING_SYSTEMS,
	...FERNWAERME_HEATING_SYSTEMS,
] as const
export type HeatingSystemType = (typeof HEATING_SYSTEMS)[number]
